import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CommonValidationErrorComponent } from "./common-validation-error.component";

const DIRECTIVES = [CommonValidationErrorComponent];

@NgModule({
	imports: [CommonModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CommonValidationErrorModule {}
